import { withInstall } from '../../utils/install';
import Collapse from './collapse.vue';

export const IvueCollapse = withInstall(Collapse);
export default IvueCollapse;

export * from './collapse.vue';
